module.exports = __webpack_public_path__ + "static/media/couple-diamond-active.1b084781.svg";